import type React from 'react'
import { createContext, useContext } from 'react'

interface PortalManagerContextValues {
  zIndex?: number
}

export const PortalManagerContext =
  createContext<PortalManagerContextValues | null>(null)

export const PortalManagerProvider =
  PortalManagerContext.Provider as React.Provider<PortalManagerContextValues>

export const usePortalManager = () => useContext(PortalManagerContext)
